/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { ArrowDCornerLeftUpIcon16Light } from './ArrowDCornerLeftUpIcon16Light';
import { ArrowDCornerLeftUpIcon16Regular } from './ArrowDCornerLeftUpIcon16Regular';
import { ArrowDCornerLeftUpIcon16Solid } from './ArrowDCornerLeftUpIcon16Solid';
import { ArrowDCornerLeftUpIcon20Light } from './ArrowDCornerLeftUpIcon20Light';
import { ArrowDCornerLeftUpIcon20Regular } from './ArrowDCornerLeftUpIcon20Regular';
import { ArrowDCornerLeftUpIcon20Solid } from './ArrowDCornerLeftUpIcon20Solid';
import { ArrowDCornerLeftUpIcon24Regular } from './ArrowDCornerLeftUpIcon24Regular';
import { ArrowDCornerLeftUpIcon24Solid } from './ArrowDCornerLeftUpIcon24Solid';
import { ArrowDCornerLeftUpIcon32Regular } from './ArrowDCornerLeftUpIcon32Regular';
import { ArrowDCornerLeftUpIcon64Regular } from './ArrowDCornerLeftUpIcon64Regular';
var sizes = {
    16: {
        light: ArrowDCornerLeftUpIcon16Light,
        regular: ArrowDCornerLeftUpIcon16Regular,
        solid: ArrowDCornerLeftUpIcon16Solid,
    },
    20: {
        light: ArrowDCornerLeftUpIcon20Light,
        regular: ArrowDCornerLeftUpIcon20Regular,
        solid: ArrowDCornerLeftUpIcon20Solid,
    },
    24: {
        regular: ArrowDCornerLeftUpIcon24Regular,
        solid: ArrowDCornerLeftUpIcon24Solid,
    },
    32: {
        regular: ArrowDCornerLeftUpIcon32Regular,
    },
    64: {
        regular: ArrowDCornerLeftUpIcon64Regular,
    },
};
export var ArrowDCornerLeftUpIcon = forwardRef('ArrowDCornerLeftUpIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
